import { Button } from "@maker/design-system/ui/button";
import { Field, FieldInput, FieldLabel } from "@maker/design-system/ui/field";
import { useToastManager } from "@maker/design-system/ui/toast";
import { Volume2Icon } from "lucide-react";
import { type ChangeEvent, type SubmitEvent, useState } from "react";
import { useParamsOrThrow } from "../../../../../hooks/use-params-or-throw";
import {
	useTranscriptionData,
	useUpdateTranscription,
} from "../../../../../hooks/use-transcriptions";
import { TranscriptionsTranscriptionVideo } from "../_elements/video";

const TranscriptionsTranscriptionParticipantsPage = () => {
	const { id } = useParamsOrThrow<"id">();
	const data = useTranscriptionData(id);
	const toastManager = useToastManager();
	const { mutate } = useUpdateTranscription();
	const [speakers, setSpeakers] = useState(data.transcription.speakers);
	const [videoTime, setVideoTime] = useState(0);

	const handleChange = (
		e: ChangeEvent<HTMLInputElement, HTMLInputElement>,
		id: string,
	) => {
		const value = e.target.value;

		setSpeakers((current) => {
			return current.map((item) => {
				if (item.id === id) {
					return {
						...item,
						name: value,
					};
				}

				return item;
			});
		});
	};

	const onSubmit = (e: SubmitEvent<HTMLFormElement>) => {
		e.preventDefault();

		mutate({ id, speakers });

		toastManager.add({
			title: "Participantes salvos com sucesso",
		});
	};

	return (
		<div className="h-full flex-1 grid-cols-1 overflow-hidden md:grid md:grid-cols-12">
			<div className="md:col-span-5 md:h-full">
				<div className="border-neutral-100 border-r bg-neutral-50 p-6 md:h-full">
					<TranscriptionsTranscriptionVideo
						src={data.url}
						currentTime={videoTime}
					/>
				</div>
			</div>

			<div className="h-full overflow-y-auto md:col-span-7">
				<div className="p-6">
					<h3 className="mb-8 font-semibold text-sm">Participantes</h3>

					<form action="" onSubmit={onSubmit}>
						{speakers.map((speaker) => (
							<div className="mb-4 flex items-end gap-2" key={speaker.id}>
								<Field className="flex-1">
									<FieldLabel>Identificador</FieldLabel>

									<FieldInput name="title" defaultValue={speaker.id} disabled />
								</Field>

								<Field className="flex-1">
									<FieldLabel>Nome</FieldLabel>

									<FieldInput
										name="title"
										value={speaker.name}
										onChange={(e) => handleChange(e, speaker.id)}
										placeholder="João"
										required
									/>
								</Field>

								<div>
									<Button
										variant="black"
										icon="sm"
										onClick={() => setVideoTime(speaker.start)}
									>
										<Volume2Icon />
									</Button>
								</div>
							</div>
						))}

						<div className="text-right">
							<Button variant="black" size="sm" type="submit">
								Salvar
							</Button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default TranscriptionsTranscriptionParticipantsPage;
